import styled, {css} from 'styled-components'
import {DialogBody, DialogFooter} from '@/components/ui/dialog-atoms/DialogAtoms'

export const StyledGenerateNrAbsencesDialogBody = styled(DialogBody)(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 4}px;
    `
)

export const StyledGenerateNrAbsencesDialogFooter = styled(DialogFooter)(
    ({theme: {spacing}}) => css`
        display: flex;
        gap: ${spacing * 2}px;
        justify-content: flex-end;
    `
)

export const StyledGenerateNrAbsencesCenteredState = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: ${spacing * 2}px;
        padding: ${spacing * 8}px 0;
        text-align: center;
    `
)

export const StyledGenerateNrAbsencesSummary = styled.div(
    ({theme: {spacing, palette}}) => css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: ${spacing * 3}px;
        padding: ${spacing * 3}px ${spacing * 4}px;
        border: 1px solid ${palette.neutral[200]};
        border-radius: 8px;
        background: ${palette.neutral[50]};
    `
)

/* Header + rows share the same track sizes so the columns stay aligned while the body scrolls. */
export const StyledGenerateNrAbsencesPlanRow = styled.div<{$isHeader?: boolean}>(
    ({theme: {spacing, palette, typography}, $isHeader}) => css`
        display: grid;
        grid-template-columns: 1fr repeat(3, 84px);
        align-items: center;
        gap: ${spacing * 2}px;
        padding: ${spacing * 2}px ${spacing * 4}px;

        & > span:not(:first-child) {
            text-align: right;
        }

        ${$isHeader
            ? css`
                  ${typography.textXs};
                  font-weight: 500;
                  color: ${palette.neutral[500]};
                  text-transform: uppercase;
                  border-bottom: 1px solid ${palette.neutral[200]};
              `
            : css`
                  ${typography.textSm};
                  color: ${palette.neutral[900]};

                  &:not(:last-child) {
                      border-bottom: 1px solid ${palette.neutral[100]};
                  }
              `}
    `
)

export const StyledGenerateNrAbsencesPlanList = styled.div(
    ({theme: {palette}}) => css`
        border: 1px solid ${palette.neutral[200]};
        border-radius: 8px;
        overflow: hidden;
    `
)

export const StyledGenerateNrAbsencesPlanScroller = styled.div`
    max-height: 260px;
    overflow-y: auto;
`

export const StyledGenerateNrAbsencesToCreate = styled.span(
    ({theme: {palette}}) => css`
        font-weight: 500;
        color: ${palette.primary[700]};
    `
)

const messageBox = css`
    display: flex;
    align-items: center;
    gap: 8px;
    border-radius: 8px;

    & svg {
        flex-shrink: 0;
    }
`

export const StyledGenerateNrAbsencesInfoBox = styled.div(
    ({theme: {spacing, palette, typography}}) => css`
        ${messageBox};
        ${typography.textSm};
        gap: ${spacing * 2}px;
        padding: ${spacing * 3}px ${spacing * 4}px;
        background: ${palette.neutral[50]};
        border: 1px solid ${palette.neutral[200]};
        color: ${palette.neutral[700]};
    `
)

export const StyledGenerateNrAbsencesWarningBox = styled.div(
    ({theme: {spacing, palette, typography}}) => css`
        ${messageBox};
        ${typography.textSm};
        gap: ${spacing * 2}px;
        padding: ${spacing * 3}px ${spacing * 4}px;
        background: ${palette.warning[50]};
        border: 1px solid ${palette.warning[200]};
        color: ${palette.warning[700]};
    `
)

export const StyledGenerateNrAbsencesErrorBox = styled.div(
    ({theme: {spacing, palette, typography}}) => css`
        ${messageBox};
        ${typography.textSm};
        gap: ${spacing * 2}px;
        padding: ${spacing * 3}px ${spacing * 4}px;
        background: ${palette.danger[50]};
        border: 1px solid ${palette.danger[200]};
        color: ${palette.danger[700]};
    `
)
